import { ResponseError } from './response-error';
const DEFAULT_REQUEST_OPTS = {
    credentials: 'include'
};
export async function fetcher(url, opts = {}) {
    const response = await fetch(url, { ...DEFAULT_REQUEST_OPTS, ...opts });
    if (!response.ok) {
        let responseError;
        try {
            const { error } = await response.json();
            responseError = error;
        }
        catch (_error) {
            responseError = response.statusText;
        }
        const method = opts.method ?? 'GET';
        throw new ResponseError({
            method,
            status: response.status,
            url: response.url,
            error: responseError
        });
    }
    return response.json();
}
